// extracted by mini-css-extract-plugin
export default {"svg-icon":"Icons_svg-icon__foHm8"};